import {Injectable} from '@angular/core';
import {SimpleModalService} from '../../../../shared/models/services/simple-modal-service';

@Injectable()
export class SubscriptionsModalService extends SimpleModalService {}
